import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6bc3a662"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "main-header" }
const _hoisted_2 = ["href"]

import { computed } from 'vue'
import { useRoute } from 'vue-router'

import env from '@/app/env'

import ButtonLogout from '@C/ui/button/ButtonLogout.vue'
import AppLogo from '@C/ui/icons/AppLogo.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'MainHeader',
  setup(__props) {

const route = useRoute()

const canLogout = computed<boolean>(() => {
  return Boolean(route.meta.canLogout)
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("header", _hoisted_1, [
    _createElementVNode("a", {
      href: _unref(env).landingUrl,
      target: "_blank"
    }, [
      _createVNode(AppLogo)
    ], 8, _hoisted_2),
    (canLogout.value)
      ? (_openBlock(), _createBlock(ButtonLogout, { key: 0 }))
      : _createCommentVNode("", true)
  ]))
}
}

})